module.exports = __webpack_public_path__ + "static/media/EuinApplication.0328e185.pdf";